import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-me"
export default class extends Controller {
  click() {
    this.element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}
